import PowerBI from '@/api/PowerBI';
import mutations from '@/store/mutations';

export default {
  namespaced: true,
  state: {
    urls: [],
    url: null
  },
  mutations: {
    [mutations.SET_URLS](state, urls) {
      state.urls = urls;
    },
    [mutations.SET_URL](state, url) {
      state.url = url;
    }
  },
  actions: {
    async getAll({ commit }, profileId) {
      try {
        const { data } = await PowerBI.getAll(profileId);
        commit(mutations.SET_URLS, data.data);
        return data;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async get({ commit }, profileId) {
      try {
        const { data } = await PowerBI.get(profileId);
        commit(mutations.SET_URL, data.data);
        return data;
      } catch (e) {
        console.log(e);
        throw e;
      }
    }
  },
  getters: {}
};
